<template>
  <div
    class="bg-surface-container rounded-medium text-on-surface-variant flex w-full flex-row items-center gap-6 p-2"
  >
    <div class="flex grow flex-row items-center gap-2">
      <div class="relative h-6 w-6 shrink-0">
        <BaseShape shape="9-sided-cookie" class="text-secondary-container h-full w-full" />
        <BaseIcon
          size="18"
          class="text-on-secondary-container absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
          >check</BaseIcon
        >
      </div>
      <h3 class="text-body-medium">{{ feedbackTopic.title }}</h3>
    </div>
    <span class="text-body-medium whitespace-nowrap">
      {{ $t('survey.schedule.nextOccurrence') }}:
      <span class="capitalize">
        {{
          useDisplayDate(task.nextOccurrenceAt, {
            dayName: 'short',
          })
        }}
      </span>
    </span>

    <span class="text-body-medium">
      {{ $t('survey.schedule.recurrence') }}:
      <span class="capitalize">
        {{ recurrenceSummaryText }}
      </span>
    </span>
  </div>
</template>

<script setup lang="ts">
  import type { FeedbackTask } from '@/modules/task/composables/useFeedbackTasks'
  import { computed } from 'vue'
  import BaseShape from '../base/shapes/BaseShape.vue'
  import BaseIcon from '../base/icon/BaseIcon.vue'
  import { useDisplayDate } from '@/core/composables/use-display-date.ts'
  import { useSurveyRecurrenceSummary } from '@/modules/start-survey/composables/use-survey-recurrence-summary.ts'

  const props = defineProps<{
    task: FeedbackTask
  }>()

  const feedbackTopic = computed(() => {
    return props.task.feedbackTopics[0]
  })

  const { recurrenceSummaryText } = useSurveyRecurrenceSummary(
    computed(() => new Date(props.task.nextOccurrenceAt || new Date())),
    computed(() => props.task.recurrence?.interval),
    computed(() => props.task.recurrence?.frequency),
    true,
  )
</script>
